import { apiCall } from '@/lib/api-client';

/** Running build identity. `sha` == the 12-char ECR image tag == the git commit. */
export interface BuildInfo {
  sha: string;
  build_time: string;
}

/**
 * The deployed build's git SHA + build time (any authenticated user).
 * `skipAuthRedirect` keeps this cosmetic badge from bouncing the user to /login —
 * if it 401s, the badge simply doesn't render.
 */
export const fetchVersion = () =>
  apiCall<BuildInfo>('/api/version', { skipAuthRedirect: true });
